//kind of enum but just a class with readonly fields
export class RouterLinkEnum {
  public static readonly PARTNERS = new RouterLinkEnum(true, '/partners', 'handshake', 'Partners', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly TUNNEL_SECTIONS = new RouterLinkEnum(false, '/tunnel_section/', '', '', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly TUNNEL_SECTIONS_DASHBOARD = new RouterLinkEnum(true, '/tunnel_sections/dashboard', 'pallets', 'Elements', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly TUNNEL_SECTIONS_LIST = new RouterLinkEnum(true, '/tunnel_sections/list', 'group', 'Elements', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly FEHMARN = new RouterLinkEnum(true, '/fehmarn', 'bar_chart_4_bars', 'Fehmarn', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly UPLOADER = new RouterLinkEnum(true, '/upload', 'upload', 'Upload', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly USERS = new RouterLinkEnum(false, '/user/', '', '', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly USERS_LIST = new RouterLinkEnum(true, '/users/list', 'group', 'Users', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly LOGIN = new RouterLinkEnum(true, '/login', '', 'Login', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly CHANGE_PASSWORD = new RouterLinkEnum(true, '/change_password', 'person', 'Change password', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly RASTERS_LIST = new RouterLinkEnum(true, '/rasters/list', 'fence', 'Rasters', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly RASTERS = new RouterLinkEnum(false, '/raster/', '', '', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly RASTERS_UPLOAD_LIST = new RouterLinkEnum(true, '/rasters_upload/list', 'upload', 'Upload rasters', 'ADMIN,UPLOADER');
  public static readonly RASTERS_UPLOAD = new RouterLinkEnum(false, '/raster_upload/', '', '', 'ADMIN,UPLOADER');
  public static readonly RASTER_CATEGORIES_LIST = new RouterLinkEnum(true, '/raster-categories/list', 'type_specimen', 'Raster categories', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly RASTER_CATEGORIES = new RouterLinkEnum(false, '/raster-categories/', '', '', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly SYSTEMPARAMS_LIST = new RouterLinkEnum(true, '/system-params/list', 'settings_applications', 'System parameters', 'ADMIN');
  public static readonly SYSTEMPARAMS = new RouterLinkEnum(false, '/system-param/', '', '', 'ADMIN');
  public static readonly LOAD_CHAINAGES_LIST = new RouterLinkEnum(true, '/load-chainages/list', 'dataset_linked', 'Load/Spring chainages', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly LOAD_CHAINAGES = new RouterLinkEnum(false, '/load-chainage/', '', '', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly SDT_POSITIONS_LIST = new RouterLinkEnum(true, '/sdt-positions/list', 'sdt_positions', 'Sdt positions', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly SDT_POSITIONS = new RouterLinkEnum(false, '/sdt-position/', '', '', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly LOG_MESSAGES_LIST = new RouterLinkEnum(true, '/log-messages/list', 'list', 'Log messages', 'ADMIN');
  public static readonly LOG_MESSAGES = new RouterLinkEnum(false, '/log-message/', '', '', 'ADMIN,UPLOADER,ENGINEER,VIEWER');
  public static readonly TUNNEL_STRESS_AREAS = new RouterLinkEnum(false, '/tunnel-stress-area/', '', '', 'ADMIN,UPLOADER,ENGINEER,VIEWER');

  // private to disallow creating other instances of this type
  private constructor(public readonly isMenuItem: boolean, public readonly link: string, public readonly menu: string, public readonly text: string
    , public readonly profiles: string) {
  }

  toString() {
    return this.link;
  }

  static getRouterLinkArray()
  {
    let enumArray: RouterLinkEnum[] = [
      RouterLinkEnum.PARTNERS,
      RouterLinkEnum.TUNNEL_SECTIONS,
      RouterLinkEnum.TUNNEL_SECTIONS_DASHBOARD,
      RouterLinkEnum.TUNNEL_SECTIONS_LIST,
      RouterLinkEnum.FEHMARN,
      RouterLinkEnum.LOGIN,
      RouterLinkEnum.UPLOADER,
      RouterLinkEnum.USERS_LIST,
      RouterLinkEnum.USERS,
      RouterLinkEnum.CHANGE_PASSWORD,
      RouterLinkEnum.RASTERS_LIST,
      RouterLinkEnum.RASTERS,
      RouterLinkEnum.RASTERS_UPLOAD,
      RouterLinkEnum.RASTERS_UPLOAD_LIST,
      RouterLinkEnum.RASTER_CATEGORIES,
      RouterLinkEnum.RASTER_CATEGORIES_LIST,
      RouterLinkEnum.SYSTEMPARAMS_LIST,
      RouterLinkEnum.SYSTEMPARAMS,
      RouterLinkEnum.LOAD_CHAINAGES,
      RouterLinkEnum.LOAD_CHAINAGES_LIST,
      RouterLinkEnum.LOG_MESSAGES,
      RouterLinkEnum.LOG_MESSAGES_LIST,
      RouterLinkEnum.TUNNEL_STRESS_AREAS,
      RouterLinkEnum.SDT_POSITIONS,
      RouterLinkEnum.SDT_POSITIONS_LIST
    ];


    return enumArray;
  }

  static getRouterLinkByLink(link: string)
  {
    let result = null;
    this.getRouterLinkArray().forEach((element) =>
    {
      if (link.includes(element.link))
      {
        result = element;
        return result;
      }
    });
    return result;
  }
}
